import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import './SolveBgResults.scss'
import { bgvSummaryColums } from "constants/application"
import { Button } from "@material-ui/core"
import { Alert } from '@material-ui/lab'
import TableComponent from "components/shared/TableComponent"
import Loader from 'components/shared/Loader'
import strings from "strings"
import { performBgvSearchSummary } from "actions/applicants"
import { saveBuisnessReport } from "actions/applicants"
import {useAppContext} from "../../../../../../../../context/AppContext";
import AuthService from "../../../../../../../../tools/AuthService";
import CreditCost from 'components/shared/CreditCost'

const SolveBgResults = ({ applicationId, requestDecision, handleGetAllData, isGetAllData = false, creditCosts }) => {

    const [backgroundSearchData, setBackgroundSearchData] = useState([])
    const { creditUsageEnabled } = AuthService.getClientFeatures();
    const [loading, setLoading] = useState(false)
    const {isDemoMode} = useAppContext()

    useEffect(() => {
        setLoading(true)
        const payLoad = {
            businessId: applicationId,
            searchByDBA: false
        }
        performBgvSearchSummary(applicationId, payLoad, isDemoMode)()
            .then((res) => {
                setBackgroundSearchData(res?.response?.TopBusinessSearchResponseEx?.response?.Records?.Record || [])
            }).finally(() => {
                setLoading(false)
            })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleSelectBusiness = (row) => {
        setLoading(true)
        const payLoad = { businessId: applicationId, lexisBusinessIds: row.BusinessIds, searchByDBA: false }
        saveBuisnessReport(applicationId, payLoad)()
            .then(() => {
                if (isGetAllData) {
                    handleGetAllData(applicationId)
                } else {
                    requestDecision()
                }
            })
            .finally(() => {
                setLoading(false)
            })
    }

    function getEndIcon() {
        if (creditCosts){
            const costObj = creditCosts.find(cost => cost.requestType === 'LEXIS_TOP_BUSINESS_REPORT');
            return costObj ? costObj.creditCost : 0;
        }
        return 0;
    }


// table columns
    const actionForBgv = {
        formatter: (cell, row, rowIndex) => {
            return (
                <div style={{width:"124px"}}>
                    <Button variant="outlined" color="primary" onClick={() => handleSelectBusiness(row)} disabled={loading}
                        endIcon={creditUsageEnabled && creditCosts ?
                        <CreditCost cost={getEndIcon()} /> : undefined}
                        >
                    {strings.SELECT}
                    </Button>
                </div>
            )
        }
    }

    bgvSummaryColums.map((item, index) => {
        if (item.dataField === 'action') {
            bgvSummaryColums[index] = { ...item, ...actionForBgv }
        }
        return item
    })

    return (
        <Row style={{overflow:'visible !important'}}>
            <Col>
                {
                    loading ?
                        <div className='summaryLoader'>
                            <Loader />
                        </div>
                        :
                        <>
                            <Alert severity="info" className="mb-3 mt-3">
                                {strings.APPLICANT.BGV.REPORT_CHARGED_ONCE}
                            </Alert>
                            <TableComponent
                                keyField="BusinessId"
                                columns={bgvSummaryColums}
                                data={backgroundSearchData}
                                showPagination={false}
                                className="customTable mt-3"
                            />
                        </>
                }
            </Col>
        </Row>
    );
}

export default SolveBgResults;